import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, CircleNotch, WarningCircle } from "@phosphor-icons/react";

export default function InvitationLanding() {
  const [state, setState] = useState("checking"); // checking | error | denied
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("e")) { setState("error"); return; }
    (async () => {
      try {
        const r = await api.post("/gov/invitations/accept");
        if (r.data?.auth_required) {
          // Retain the pending invitation securely and continue via normal email/password login.
          navigate("/login");
          return;
        }
        if (r.data?.ok) { navigate(`/gov/visits/${r.data.gov_visit_id}`); return; }
        setState("error");
      } catch (e) {
        setState(e?.response?.status === 403 ? "denied" : "error");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="invitation-landing">
      <div className="max-w-md w-full border border-border bg-surface rounded-md p-8 text-center">
        <div className="h-10 w-10 bg-primary rounded flex items-center justify-center mx-auto"><ShieldCheck size={22} weight="fill" className="text-white" /></div>
        {state === "checking" && (
          <>
            <h1 className="mt-5 t-section-title">Completing sign-in…</h1>
            <p className="mt-2 t-support text-muted-foreground flex items-center justify-center gap-2"><CircleNotch size={16} className="animate-spin text-primary" weight="bold" /> Opening your Governor's Visit overview.</p>
          </>
        )}
        {(state === "error" || state === "denied") && (
          <>
            <div className="mt-5 mx-auto h-10 w-10 flex items-center justify-center text-amber-600"><WarningCircle size={32} weight="duotone" /></div>
            <h1 className="mt-3 t-section-title" data-testid="invite-error-title">Invitation unavailable</h1>
            <p className="mt-2 t-support text-muted-foreground">
              {state === "denied"
                ? "This invitation cannot be used with the signed-in account. Please sign in as the invited club officer."
                : "This invitation link is invalid, expired, revoked or has already been used."}
            </p>
            <button onClick={() => navigate("/")} className="mt-5 inline-flex items-center gap-2 border border-border px-5 py-2.5 t-support font-semibold rounded-md hover:bg-secondary">Go to dashboard</button>
          </>
        )}
      </div>
    </div>
  );
}
